import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import EventRepeatOutlinedIcon from "@mui/icons-material/EventRepeatOutlined";
import { alpha } from "@mui/material/styles";

/**
 * A client whose current pack is booked ahead can buy the next one to carry on
 * from the day after their last session, rather than starting it on top of the
 * sessions they already hold.
 */
function PackContinuationBanner({ title, subtitle, actionLabel, onAction, sx }) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: { xs: "flex-start", sm: "center" },
        flexWrap: "wrap",
        gap: 1.5,
        p: { xs: 1.5, md: 2 },
        borderRadius: 2.5,
        border: "1px solid",
        borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.06),
        ...sx
      }}
    >
      <EventRepeatOutlinedIcon sx={{ color: "primary.main", fontSize: "1.5rem", flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: "10rem" }}>
        <Typography sx={{ fontWeight: 600, fontSize: { xs: "0.85rem", md: "0.9375rem" } }}>{title}</Typography>
        {subtitle && <Typography sx={{ color: "text.secondary", fontSize: { xs: "0.72rem", md: "0.8125rem" } }}>{subtitle}</Typography>}
      </Box>
      {onAction && (
        <Button
          variant="contained"
          size="small"
          onClick={onAction}
          sx={{ flexShrink: 0, flexBasis: { xs: "100%", sm: "auto" }, textTransform: "none", fontWeight: 700 }}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
}

export default PackContinuationBanner;
